import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './Tt.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export default function TtIcon(props: IconProps) {
  return <Icon tw="fill-current" className={props.className} />;
}
